import { Component, Input } from '@angular/core';

@Component({
  selector: 'bid-content-border-info',
  templateUrl: './content-border-info.component.html',
  styleUrls: ['./content-border-info.component.scss'],
})
export class ContentBorderInfoComponent {
  @Input() iconClass;
  @Input() mainTxt;
  @Input() type;
  @Input() typeTotalPercent;
  @Input() contentTxt;
  @Input() letter = '';
  @Input() tooltipInfo: string;
  @Input() noIcon: boolean;
}
